/**
 * @class PosForm
 */
export default class PosForm {
    /**
     * @param {String} contactName
     * @param {String} url
     * @param {String} zipCode
     * @param {String} address
     * @param {String} email
     * @param {String} secondAddress
     * @param {String} phone
     * @param {String} city
     * @param {String} shopName
     * @param {String} shopIdentification
     * @param {String} machineIdentification
     */
    constructor(
        shopName,
        url = "",
        zipCode = "",
        address = "",
        email = "",
        secondAddress = "",
        phone = "",
        city = "",
        contactName = "",
        shopIdentification = "",
        machineIdentification = ""
    ) {
        this._shopName = shopName;
        this._url = url;
        this._zipCode = zipCode;
        this._address = address;
        this._email = email;
        this._secondAddress = secondAddress;
        this._phone = phone;
        this._city = city;
        this._contactName = contactName;
        this._shopIdentification = shopIdentification;
        this._machineIdentification = machineIdentification;
    }

    /**
     * @return {String}
     */
    get url() {
        return this._url;
    }

    /**
     * @param {String} url
     */
    set url(url) {
        this._url = url;
    }

    /**
     * @return {String}
     */
    get contactName() {
        return this._contactName;
    }

    /**
     * @param {String} contactName
     */
    set contactName(contactName) {
        this._contactName = contactName;
    }

    /**
     * @return {String}
     */
    get zipCode() {
        return this._zipCode;
    }

    /**
     * @param {String} zipCode
     */
    set zipCode(zipCode) {
        this._zipCode = zipCode;
    }

    /**
     * @return {String}
     */
    get address() {
        return this._address;
    }

    /**
     * @param {String} address
     */
    set address(address) {
        this._address = address;
    }

    /**
     * @return {String}
     */
    get email() {
        return this._email;
    }

    /**
     * @param {String} email
     */
    set email(email) {
        this._email = email;
    }

    /**
     * @return {String}
     */
    get secondAddress() {
        return this._secondAddress;
    }

    /**
     * @param {String} secondAddress
     */
    set secondAddress(secondAddress) {
        this._secondAddress = secondAddress;
    }

    /**
     * @return {String}
     */
    get phone() {
        return this._phone;
    }

    /**
     * @param {String} phone
     */
    set phone(phone) {
        this._phone = phone;
    }

    /**
     * @return {String}
     */
    get city() {
        return this._city;
    }

    /**
     * @param {String} phone
     */
    set city(city) {
        this._city = city;
    }

    /**
     * @return {String}
     */
    get shopName() {
        return this._shopName;
    }

    /**
     * @param {String} shopName
     */
    set shopName(shopName) {
        this._shopName = shopName;
    }

    /**
     * @return {String}
     */
    get shopIdentification() {
        return this._shopIdentification;
    }

    /**
     * @param {String} shopIdentification
     */
    set shopIdentification(shopIdentification) {
        this._shopIdentification = shopIdentification;
    }

    /**
     * @return {String}
     */
    get machineIdentification() {
        return this._machineIdentification;
    }

    /**
     * @param {String} machineIdentification
     */
    set machineIdentification(machineIdentification) {
        this._machineIdentification = machineIdentification;
    }

    /**
     * @return {Array}
     */
    get props() {
        return [
            "shopName",
            "url",
            "zipCode",
            "address",
            "email",
            "secondAddress",
            "phone",
            "city",
            "contactName",
            "shopIdentification",
            "machineIdentification"
        ];
    }
}
